import v35 from './v35.js';
import md5 from './md5.js';
var v3 = v35('v3', 0x30, md5);
export default v3;


//////////////////
// WEBPACK FOOTER
// /var/www/html/web/app/themes/wakanda/node_modules/uuid/dist/esm-browser/v3.js
// module id = 22
// module chunks = 0 1 2 3 4 5 6 7 8